import {
  bottomColumns,
  bottomLeftColumn,
  bottomOverlay,
  expandButton,
  feedCard,
  imageContainer,
  rightActions,
  skeletonBar,
  skeletonCircle,
  skeletonPhoto,
} from './feedCard.styles';

const FeedCardSkeleton = () => (
  <div className={feedCard} aria-hidden="true">
    <div className={imageContainer}>
      <div className={skeletonPhoto} />
    </div>

    <div className={bottomOverlay}>
      <div className={bottomColumns}>
        <div className={bottomLeftColumn}>
          <div className={skeletonBar} style={{ width: '60%', height: '20px', marginBottom: 4 }} />
          <div className={skeletonBar} style={{ width: '40%', marginBottom: 8 }} />
          <div className={skeletonBar} style={{ width: '30%', height: '28px', marginBottom: 4 }} />
          <div className={skeletonBar} style={{ width: '45%', marginBottom: 8 }} />
          <div className={expandButton} style={{ opacity: 0.3, pointerEvents: 'none' }}>
            &nbsp;
          </div>
        </div>
        <div className={rightActions}>
          <div className={skeletonCircle} />
          <div className={skeletonCircle} />
          <div className={skeletonCircle} />
        </div>
      </div>
    </div>
  </div>
);

export default FeedCardSkeleton;
